<tt-tree-view
    *ngIf="!!get"
    ttDraggable
    [ttRememberId]="'w_email.selected_folder_id.' + get.current_account_email + '.' + get.current_mailbox"
    [ttRememberIdExpanded]="'w_email.expandedfolders.' + get.current_account_email + '.' + get.current_mailbox"
    ttDataId="id"
    ttDataParentId="parentFolderId"
    ttDataName="displayName"
    [(ttSelectedId)]="get.selected_folder_id"
    (ttOnSelect)="selectedFolderChange.emit($event)"
    ttUseDataSourceDirective
    ttEmailFolderTreeDataSource
    [userId]="get.current_mailbox"
></tt-tree-view>
